export default __webpack_public_path__ + "static/media/boy2.fd206a96.PNG";